import registry from "@patternslib/patternslib/src/core/registry";
import "./src/leaflet";

registry.init();
